import { Box, Typography } from '@material-ui/core';
import { Cake, CakeContent } from '@campfire/cake';
import { CampfireRichEditor } from '@campfire/campfire-rich-editor';
import { convertFromRaw, EditorState } from 'draft-js';
import React, { useMemo } from 'react';
import { useCampfireTheme } from '../../theme/useCampfireTheme';

export const SUYPLimbo = ({ preferredName, content }: { preferredName?: string; content?: string | null }) => {
  const { isMobile } = useCampfireTheme();

  const editorState = useMemo(() => {
    if (!content) return null;
    try {
      const contentState = convertFromRaw(JSON.parse(content));
      return contentState.hasText() ? EditorState.createWithContent(contentState) : null;
    } catch {
      return null;
    }
  }, [content]);

  return (
    <Box
      width={1}
      height={1}
      display='flex'
      justifyContent='center'
      alignContent='flex-start'
      alignItems='flex-start'
      paddingTop={isMobile ? 3 : 5}
      paddingX={isMobile ? 1 : 2}
      boxSizing='border-box'
    >
      <Box width={1} maxWidth={720}>
        <Cake>
          <CakeContent>
            <Box paddingY={3} paddingX={isMobile ? 1 : 2} textAlign={isMobile ? 'center' : 'start'}>
              <Typography variant='h5' style={{ fontWeight: 'bold' }} gutterBottom>
                <span role='img' aria-label='yay' style={{ marginRight: 16 }}>
                  🎉
                </span>
                {preferredName ? `Thanks, ${preferredName}` : `Profile completed`}
              </Typography>
              {editorState ? (
                <Box textAlign='start'>
                  <CampfireRichEditor editorState={editorState} readOnly />
                </Box>
              ) : (
                <>
                  <Typography variant='body2' gutterBottom>
                    Your profile has been received and is awaiting review!
                  </Typography>
                  <Typography variant='body2'>
                    {`We'll email you as soon as a manager has looked at your profile.`}
                  </Typography>
                </>
              )}
            </Box>
          </CakeContent>
        </Cake>
      </Box>
    </Box>
  );
};
